import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ element: Component }) => {
  const { user, token, loading } = useAuth();
  const location = useLocation();
  const isRegistering = sessionStorage.getItem("isRegistering");

  // console.log("[ProtectedRoute] Checking access", { token, loading, path: location.pathname, isRegistering });

  if (loading) {
    return <div>Loading...</div>;
  }


  if (!token) {
    if (isRegistering === "true" && location.pathname === "/registration") {
      // console.log("[ProtectedRoute] Allowing user to stay on /registration");
      return <Component />;
    }

    // console.log("[ProtectedRoute] No token found, redirecting to onboarding");
    return <Navigate to="/" replace />;
  }

  // Authenticated but BLOCKED: show different block page based on blockType
  if (user && user.isBlocked === true) {
    if (user.blockType === "permanent") {
      return <Navigate to="/permanently-blocked" replace />;
    } else if (user.blockType === "temporary") {
      return <Navigate to="/temporarily-blocked" replace />;
    } else {
      // Fallback for unknown block type, you can handle or log this case
      return <Navigate to="/permanently-blocked" replace />;
    }
  }

  // console.log("[ProtectedRoute] Token found, rendering protected component");
  return <Component />;
};

export default ProtectedRoute;
